import React from "react";

const InputTest = ({
  placeholder,
  id,
  nameInput,
  type,
  onChange,
  label,
  error,
  value,
  icon,
  autoFocus,
}) => {
  return (
    // <div className="label-input">
    //   <label>{label}</label>

    <input
      id={id}
      value={value}
      name={nameInput}
      type={type}
      autoFocus={autoFocus}
      placeholder={placeholder}
      className="hitfit-input"
      // className="tm-input-popup"
      required
      onChange={onChange}
    />

    //   <label style={{ color: "red" }}>{error}</label>
    // </div>
  );
};

export default InputTest;
